import { createSelector } from 'reselect'

const getCountries = ({ signup }) => signup.countries
const getIndustries = ({ signup }) => signup.industries

const signupSelectors = {
  getSignupCountries: createSelector([getCountries], (countries) => {
    return countries.map((country) => ({
      label: country.name,
      value: country,
    }))
  }),
  getSignupIndustries: createSelector([getIndustries], (industries) => {
    return industries
      .map((industry) => ({
        label: industry.value.name,
        value: industry.value,
      }))
      .sort((option1, option2) => {
        if (option1.label > option2.label) {
          return 1
        }
        if (option1.label < option2.label) {
          return -1
        }
        return 0
      })
  }),
}
// Test
export default signupSelectors
